
import React, {useState} from 'react';
import { useHistory } from 'react-router-dom';
import { Button, createTheme, Grid, TextField, ThemeProvider, Typography } from '@mui/material';
import { uniqueNamesGenerator, adjectives, animals } from 'unique-names-generator';

import "./LandingPage.css"
import logo from "../../assets/SMLR_logo.svg"
import { ensureSeriesSession } from '../../meeting/v2Api';


const landingPageTheme = createTheme({
  palette: {
    primary: {
      main: '#a8a8a8',
    },
    secondary: {
      main: '#f50057',
    },
  },
});

interface LandingPageProps {
    setHomepageMeetingID : Function
    setMEETING_ID : Function
}

export const LandingPage = (props :LandingPageProps): React.ReactElement => {
  const {setHomepageMeetingID, setMEETING_ID} = props

  const generateRandomName = () => {
    let randomName = uniqueNamesGenerator({
      dictionaries: [adjectives, animals],
      length : 2,
      separator: ' ',
      style : "capital"
    })
    return randomName + " Meeting"
  }
  const [meetingName , setMeetingName] = useState(generateRandomName())
  const [meetingDuration, setMeetingDuration] = useState('30')
  const [displayMeetingNameInstructions, setDisplayMeetingNameInstructions] = useState(false)
  const [displayMeetingDurationInstructions, setDisplayMeetingDurationInstructions] = useState(false)
  const history = useHistory();

  const handleCreateMeeting = async () =>{
    const meetingObj : MeetingMetaData = {
      id: "",
      name: meetingName, 
      duration: (parseInt(meetingDuration) * 60), 
      presenterOrder:[], 
      cursor:-1, 
      debug:false,  
      indexToStealFrom : -1, 
      startTime:"" , 
      display:true, 
      endTime:""
    }

    const urlName = meetingName.split(' ').join('_');

    console.log("KENDRA Creating meeting with ", urlName, {...meetingObj});
    ensureSeriesSession(urlName, meetingName, meetingObj.duration)
      .then((state) => {
        setHomepageMeetingID(state.seriesId);
        setMEETING_ID(state.seriesId);
        history.push('/' + state.seriesId);
      })
      .catch((err) => console.log('ERROR CREATING MEETING', err));
  }

  const setMeetingDurationWithInputValidation = ( duration: string ) => {
    if ((/^\d+$/.test(duration) && parseInt(duration) < 720) || duration === "") setMeetingDuration(duration.toString());
    else setDisplayMeetingDurationInstructions(true);
  }

  // TODO: Advanced feature - check if meeting name already exists and warn user
  const setMeetingNameWithInputValidation = ( name: string ) => {
    if ((/^[a-zA-Z0-9\s]+$/.test(name)) || name === "") setMeetingName(name.toString())
    else setDisplayMeetingNameInstructions(true);
  }

  const setMeetingNameOnBlur = () => {
    if (meetingName === "") setMeetingName(generateRandomName())
    setDisplayMeetingNameInstructions(false);
  }

  const setMeetingDurationOnBlur = () => {
    if (meetingDuration === "") setMeetingDuration('30');
    setDisplayMeetingDurationInstructions(false);
  }

  return (
    <ThemeProvider theme={landingPageTheme}>
      <Grid container alignItems={"center"} id="landing-page-container">
        <Grid container item xs={9}  justifyContent="flex-start">
          <Grid container item id="logo_motto_content">
            <img className="SMLR_logo" src={logo} id="SMLR_logo" alt="Meeting SMLR Logo"/>
            <Typography variant='h4' component="h4" id="font-face">
              The best way to keep your meetings on track.
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <div id="landing-page-backsplash"></div>
        </Grid>
        <Grid container item id="text_box" direction='column' alignItems="center" justifyContent="center">
          <img className="SMLR_logo" src={logo} id="SMLR_logo_above" alt="Meeting SMLR Logo"/>
          <Typography variant="h3" id="header">
            Create a new meeting
          </Typography>
          <TextField className="textField" inputProps={{style: { fontSize: 30}}}  variant="standard"  value={meetingName} onChange={(event) => setMeetingNameWithInputValidation(event.target.value)} label="Meeting name" color='secondary' onBlur={setMeetingNameOnBlur}/>
          <p className='instructions' style={{visibility: displayMeetingNameInstructions? 'visible': 'hidden' }}> *** Meeting names cannot contain special characters </p>
          <TextField className="textField" inputProps={{style: { fontSize: 30}}} variant="standard" value={meetingDuration} onChange={(event) => setMeetingDurationWithInputValidation(event.target.value)} label="Duration (min)" color='secondary' onBlur={setMeetingDurationOnBlur}/>
          <p className='instructions' style={{visibility: displayMeetingDurationInstructions? 'visible': 'hidden' }}>*** Durations must be whole positive numbers</p>
          <Button id="createButton" onClick={handleCreateMeeting} variant="contained" color="secondary">
            Create
          </Button>
        </Grid>
      </Grid>
    </ThemeProvider>
  )
}